// Use a default bridge in case bridge goes down.

import { store } from "../../redux/store";

// This should stop any requests to bridge because auth will fail.
const defaultBridge = {
  Session: {},
  Assets: {},
  Adoptions: {},
  Groups: {},
  Ancillaries: {},
  Promotions: {},
  Store: {}
};
const VSTBridge = window.VST
  ? window.VST.Bridge || defaultBridge
  : defaultBridge;

const cachedBridgeData = {};
let inFlightSessionGet = false;
const inFlightSessionGets = [];

const BridgeAPI = {
  ...VSTBridge,
  Session: {
    ...VSTBridge.Session,
    get: (args, force) => {
      return new Promise((resolve, reject) => {
        if (cachedBridgeData.SessionGet && !force) {
          resolve(cachedBridgeData.SessionGet);
        } else if (inFlightSessionGet) {
          // Save off a bunch of other session requests that may get fired off.
          inFlightSessionGets.push({ resolve, reject });
        } else {
          inFlightSessionGet = true;
          VSTBridge.Session.get(args)
            .then(response => {
              inFlightSessionGet = false;
              if (response.status === 200) {
                cachedBridgeData.SessionGet = response;
                resolve(response);
                inFlightSessionGets.forEach(r => r.resolve(response));
              } else {
                reject(response);
                inFlightSessionGets.forEach(r => r.reject(response));
              }
            })
            .catch(error => {
              inFlightSessionGet = false;
              reject(error);
            });
        }
      });
    },
    logout: () => {
      VSTBridge.Session.logout();
    }
  },
  Adoptions: {
    ...VSTBridge.Adoptions,
    list: args =>
      new Promise((resolve, reject) =>
        VSTBridge.Adoptions.list(args)
          .then(response => {
            const { adoptions, ...data } = response;
            resolve({ ...data, content: adoptions });
          })
          .catch(reject)
      )
  },
  Promotions: {
    ...VSTBridge.Promotions,
    activate: VSTBridge.Promotions ? VSTBridge.Promotions.activate : () => {},
    return: VSTBridge.Promotions ? VSTBridge.Promotions.return : () => {}
  },
  Assets: {
    ...VSTBridge.Assets,
    list: VSTBridge.Assets.list,
    activate: VSTBridge.Assets.activate,
    return: VSTBridge.Assets.return,
    lists: VSTBridge.Assets.lists,
    get: VSTBridge.Assets.get
  },
  Ancillaries: {
    ...VSTBridge.Ancillaries,
    get: VSTBridge.Ancillaries ? VSTBridge.Ancillaries.get : () => {}
  },
  Store: {
    ...VSTBridge.Store,
    list:
      VSTBridge.Store && VSTBridge.Store.Assets
        ? VSTBridge.Store.Assets.list
        : () => {}
  }
};

window.BridgeAPI = BridgeAPI;
export default BridgeAPI;
